import { Button } from "@shared/components";
import { BUTTON_SIZE } from "@shared/components/button/types";
import { FC } from "react";

export const VetifyCertificateIllustrationUrl =
  "https://faradars.org/wp-content/uploads/2025/10/04/vector.svg";

const VerifyCertificateInfoSection: FC = () => {
  return (
    <div className="section-container grid grid-cols-12 gap-4     mx-auto px-4     pt-6  pb-20 md:pt-20 ">
      <div className="col-span-12 md:col-span-6 flex justify-center">
        <img
          src={VetifyCertificateIllustrationUrl}
          alt="Achieve certificate illustration faradars"
        />
      </div>
      <div className="col-span-12 md:col-span-6 w-full flex flex-col items-center md:items-start mt-3">
        <p className="text-center md:text-right headline-md md:headline-lg mb-2  text-fds-primary">
          یادگیری و کسب گواهینامه
        </p>
        <p className="body-md md:body-lg text-fds-primary max-w-[480px] text-center md:text-right">
          اگر تا به حال یادگیری را با فرادرس تجربه نکرده‌ای و علاقه‌مند به ارتقا
          مهارت‌های فردی هستی همین حالا یادگیری را شروع کن. ‌
        </p>
        <Button
          className="w-[200px] mt-6  md:mt-10"
          size={BUTTON_SIZE.LARGE}
          href="/explore?certificate=with"
        >
          جستجو و شروع یادگیری
        </Button>
      </div>
    </div>
  );
};

export default VerifyCertificateInfoSection;
